// extracted by mini-css-extract-plugin
module.exports = {"colorEmphasis":"Picture_colorEmphasis__2v9Ds","inputGroup":"Picture_inputGroup__3Qpok","inputPicture":"Picture_inputPicture__1OzY8","input":"Picture_input__3Xbtx"};